// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2338d31b","239":"bbec4d8f","667":"7c89be63"}[chunkId] + ".chunk.js";
};